<template>
  <div class="benchmark_example" id="nemobench-examples">
    <div class="title">Examples of Needle in a Montage</div>
    <div class="cont_task">
      <ul class="left_nav">
        <li v-for="(item, index) in leftNavList" :key="index" :class="{ title: true, active: navIndex === index }" @click="navActive(index)">{{ item }}</li>
      </ul>
      <div class="right_box">
        <ul class="example_ul">
          <li v-for="(item, index) in exampleList" :key="index" :class="{ active: exampleIndex === index }" @click="exampleActive(index)">{{ item }}</li>
        </ul>
        <div class="example_inner">
          <video :src="currentExample.video" :poster="currentExample.poster" controls class="example_video"></video>
          <div class="example_choice">
            <div class="topic">Question:<br />{{ currentExample.question }}</div>
            <div class="topic" v-html="currentExample.answer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 1. 提前定义一个空的事件处理函数，用于覆盖残留事件
const emptyFullscreenHandler = () => {};

export default {
  name: "ExampleList",
  data() {
    return {
      navIndex: 0,
      exampleIndex: 0,
      leftNavList: ["Short Montage", "Medium Montage", "Long Montage"],
      exampleList: ["Object Needle Grounding", "Scene Needle Grounding"],
      examplesData: {
        ExampleShortObject: {
          video: require("../../assets/videos/short_object.mp4"),
          question: "When is green lawn in front of the palace displayed in the video?",
          answer: "Ground-truth answer: <br>00:00:05 - 00:00:08",
        },
        ExampleShortScene: {
          video: require("../../assets/videos/short_scene.mp4"),
          question: "When was the scene with the vase in front of the mesh fence and plants shown in the video?",
          answer: "Ground-truth answer: <br>00:00:25 - 00:00:46",
        },
        ExampleMediumObject: {
          video: require("../../assets/videos/medium_object.mp4"),
          poster: require("@/assets/videos/medium_object.jpg"),
          question: "At what time in the video is the traditional long robe worn by the individual holding a book visible?",
          answer: "Ground-truth answer: <br>00:01:13 - 00:01:19",
        },
        ExampleMediumScene: {
          video: require("../../assets/videos/medium_scene.mp4"),
          question: "When does the scene of a panda sitting near a metal enclosure and looking upward appear in the video?",
          answer: "Ground-truth answer: <br>00:00:19 - 00:00:22, <br>00:00:28 - 00:00:32, <br>00:01:49 - 00:01:52",
        },
        ExampleLongObject: {
          video: require("../../assets/videos/long_object_scene.mp4"),
          question: "When does the video feature a multi-tiered wooden pagoda?",
          answer: "Ground-truth answer: <br>00:03:44 - 00:03:47, <br>00:08:48 - 00:08:52, <br>00:11:54 - 00:11:58",
        },
        ExampleLongScene: {
          video: require("../../assets/videos/long_object_scene.mp4"),
          question: "When does the scene of a man wearing glasses and a black leather jacket seated in front of a dark background appear in the video?",
          answer: "Ground-truth answer: <br>00:14:52 - 00:14:55, <br>00:21:18 - 00:21:22",
        },
      },
    };
  },
  computed: {
    currentMontage() {
      const types = ["Short", "Medium", "Long"];
      return types[this.navIndex];
    },
    currentTask() {
      return this.exampleIndex === 0 ? "Object" : "Scene";
    },
    currentExample() {
      return this.examplesData[`Example${this.currentMontage}${this.currentTask}`];
    },
  },
  methods: {
    navActive(index) {
      this.navIndex = index;
    },
    exampleActive(index) {
      this.exampleIndex = index;
      // 切换视频时强制退出全屏
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => console.log("退出全屏失败:", err));
      }
    },
    // 2. 兼容方案：清除残留全屏事件（无需私有API）
    clearResidualFullscreenEvents() {
      const eventNames = ["fullscreenchange", "webkitfullscreenchange", "msfullscreenchange"];
      // 先移除可能残留的旧事件（即使不知道具体函数，重复移除也不会报错）
      eventNames.forEach((eventName) => {
        // 覆盖所有监听：先绑定空函数，再移除，间接清除旧事件影响
        document.removeEventListener(eventName, emptyFullscreenHandler);
        document.addEventListener(eventName, emptyFullscreenHandler);
        document.removeEventListener(eventName, emptyFullscreenHandler);
      });
    },
  },
  mounted() {
    // 3. 组件挂载时清除残留事件
    this.clearResidualFullscreenEvents();
  },
  beforeDestroy() {
    // 4. 组件销毁时再次清理，防止内存泄漏
    this.clearResidualFullscreenEvents();
    // 退出全屏
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((err) => console.log("退出全屏失败:", err));
    }
  },
};
</script>

<style lang="scss" scoped>
$mobile: 768px; // 移动端（≤768px）
$tablet: 1024px; // 平板（≤1024px）

.benchmark_example {
  width: 100%;
  margin: 40px auto 0;
  padding: 0 15px;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
  }

  .cont_task {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .left_nav {
      width: 100%;
      background: #1b222e;
      border-radius: 18px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px 0px;
      margin-bottom: 20px;
      overflow-x: auto;

      li {
        min-width: 120px;
        height: 50px;
        line-height: 50px;
        margin: 0 4px;
        border-radius: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #d0d0d0;
        text-align: center;
        font-style: normal;
        padding: 0px 8px;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;

        &.active {
          background: #ff621f;
          color: #ffffff;
        }
      }
    }

    .right_box {
      width: 100%;
      background: rgba(27, 34, 46, 0.66);
      border-radius: 18px;
      display: flex;
      flex-direction: column;
      padding: 15px;

      .example_ul {
        width: 100%;
        height: 50px;
        border-radius: 25px;
        border: 1px solid #485263;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 0 0 20px 0;
        padding: 0;

        li {
          // width: 48%;
          height: 36px;
          border-radius: 18px;
          border: 1px solid #485263;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #b7b7b7;
          text-align: center;
          font-style: normal;
          cursor: pointer;
          list-style: none;
          flex-shrink: 0;
          &.active {
            border: 1px solid #ff621f;
            color: #ff621f;
          }
        }
      }

      .example_inner {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .example_video {
          width: 100%;
          max-width: 519px;
          background: #1b222e;
          border: 1px solid #485263;
          border-radius: 18px;
          margin-bottom: 20px;
          min-width: 210px;
        }

        .example_choice {
          width: 100%;
          max-width: 519px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .topic {
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-size: 16px;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}

@media (min-width: $mobile + 1) and (max-width: $tablet) {
  .title {
    font-size: 36px;
    margin-bottom: 25px;
    height: auto;
  }
  .cont_task {
    flex-direction: row;

    .left_nav {
      width: 200px;
      flex-direction: column;
      margin-bottom: 0;
      margin-right: 20px;

      li {
        width: 32%;
        // width: auto;
        margin: 10px auto;
      }
    }

    .right_box {
      width: calc(100% - 220px);

      .example_ul {
        justify-content: space-around;
        li {
          width: 48%;
        }
      }

      .example_inner {
        flex-direction: row;
        justify-content: space-between;

        .example_choice {
          margin-left: 20px;
        }
      }
    }
  }
}

@media (max-width: $mobile) {
  .benchmark_example {
    .title {
      font-size: 26px;
      margin-bottom: 20px;
      height: auto;
    }

    .example_ul {
      overflow-x: auto;
      li {
        width: auto !important;
        line-height: 1;
        padding: 0px 4px;
        font-size: 14px;
        white-space: nowrap;
        margin: 0 4px;
      }
    }

    .topic {
      font-size: 14px !important;
    }
  }
}
</style>
